{
  "innsynstype_logg": "logg",
  "innsynstype_innsyn": "innsyn",
  "xml_upload_button": "Se resultat",
  "xml_reset_button": "Tøm skjema",
  "dokumentasjon_heading": "Dokumentasjon",
  "error_format": "Ugyldig format",
  "error_generic_title": "Det har skjedd en feil",
  "error_xmlfield_description": "Fjern eller korriger innholdet og prøv på nytt.",
  "error_xmlfield_title": "Innhold som er limt inn feiler ved validering mot XSD-skjemaet!",
  "error_xmlformat_description": "Fjern eller korriger benyttet XML og prøv på nytt.",
  "error_xmlvalidation_description": "Fjern eller korriger benyttet XML og prøv på nytt.",
  "xml_documentation_link": "Dokumentasjon av XML-struktur",
  "xml_textarea_label": "Legg inn xml",
  "error_xmlformat_title": "Filen har feil format og ble ikke lastet opp.",
  "error_xmlvalidation_title": "Benyttet XML feiler ved validering mot XSD-skjemaet.",
  "xml_file_label": "Last opp xml-fil",
  "result_heading": "Resultat",
  "xml_schema_link": "XML-skjema",
  "xml_example_link": "XML-eksempel",
  "error_default_title": "Teknisk feil",
  "error_default_description": "Prøv igjen senere.",
  "page_testregisterinnsyn_title": "Test registerinnsyn"
}
